<template>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label><strong>Cliente</strong></label>
        <p>{{ dado.cliente_exibicao }}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label><strong>Imóvel</strong></label>
        <p>{{ dado.imovel_exibicao }}</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <label><strong>Corretor</strong></label>
        <p>{{ dado.corretor_exibicao }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Tipo Imóvel</strong></label>
        <p>{{ dado.tipo_imovel }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Valor do Imóvel:</strong></label>
        <p class="text-center">{{ dado.valor }}</p>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label><strong>Valor do Financiamento:</strong></label>
        <p class="text-center">{{ dado.valor_financiamento }}</p>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label><strong>Análista</strong></label>
        <p>{{ dado.analista }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Data Cadastro</strong></label>
        <p>{{ dado.data_cadastro }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Data Avaliação</strong></label>
        <p>{{ dado.data_avaliacao }}</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label><strong>Observações da Análise</strong></label>
        <p>{{ dado.observacoes }}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label><strong>Descritivo</strong></label>
        <p>{{ dado.descritivo }}</p>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label><strong>Fase</strong></label>
        <p>{{ dado.fase }}</p>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label><strong>Status</strong></label>
        <p v-html="dado.status"></p>
      </div>
    </div>
  </div>
  <hr>
  <button class="btn btn-success font-bold" @click="$emit('fechar')">
    Fechar
  </button>

</template>

<script>
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "InformacoesAnalise",
  props: {
    itemKey: String,
  },
  data() {
    return {
      dado: 1,
      erro: null,
    };
  },
  emits: ['fechar'],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.analises.retrieveUpdateDestroy(this.itemKey)}?modo=info`);
      if (resultado.success) {
        this.dado = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
